import script from "./StudioTimesLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioTimesLayout.vue?vue&type=script&setup=true&lang=js"

import "./StudioTimesLayout.vue?vue&type=style&index=0&id=13105e78&lang=css"

const __exports__ = script;

export default __exports__